module.exports = __webpack_public_path__ + "static/card1-e662339ea80d76a9dca2767ad46d2261.jpg";